import { ColumnType } from "antd/es/table";
import { Flex, Typography } from "antd";
import { BID_STATUSES, BidEntityByContract, BidRequestStatus } from "interfaces";
import { Status } from "ui";
import { dateFormat, formatWithDecimals } from "utils";
import CoinsStackIcon from "images/coins-stack.svg";

export const getColumns = (): Array<ColumnType<BidEntityByContract>> => {
  return [
    {
      dataIndex: "hid",
      key: "hid",
      title: "Номер заявки",
      width: 300,
      render: (_: any, record: BidEntityByContract) => {
        return (
          <Flex gap="small">
            <div className="square icon-3xl bg-basic-200">
              <img src={CoinsStackIcon} alt="" />
            </div>
            <Flex vertical gap="2px">
              <Typography.Text strong>
                {formatWithDecimals(record.fiatAmount)} {record.fiatCurrency}
              </Typography.Text>
              <Typography.Text type="secondary">Заявка №{record.hid}</Typography.Text>
            </Flex>
          </Flex>
        );
      },
    },
    {
      dataIndex: "status",
      key: "status",
      title: "Статус",
      width: 300,
      align: "right",
      render: (_: any, record: BidEntityByContract) => {
        const { status, statusDate } = record;
        return (
          <Status
            color={BID_STATUSES.colors[status]}
            children={BID_STATUSES.texts[status]}
            date={dateFormat(statusDate, true)}
          />
        );
      },
    },
  ].filter((c) => !!c) as ColumnType<BidEntityByContract>[];
};
